export const getIconForSoftwareType = (
  type: string | undefined
): string | undefined => {
  if (type === undefined) return "LPTIconSmall.webp";
  if (type.toLowerCase().includes("web")) return "ASM WEB.webp";
  if (type.toLowerCase().includes("asm")) return "ASM.webp";
  if (type.toLowerCase().includes("spectras")) return "Spectras.webp";
  if (type.toLowerCase().includes("lsm")) return "LSM.webp";
  if (type.toLowerCase().includes("spectrum")) return "SpectrumNet.webp";
  if (type.toLowerCase().includes("leo")) return "LEO.webp";
  return "LPTIconSmall.webp";
};
